import { render, staticRenderFns } from "./AssetParameters.vue?vue&type=template&id=d2e4fad4&scoped=true&"
import script from "./AssetParameters.vue?vue&type=script&lang=js&"
export * from "./AssetParameters.vue?vue&type=script&lang=js&"
import style0 from "./AssetParameters.vue?vue&type=style&index=0&id=d2e4fad4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2e4fad4",
  null
  
)

export default component.exports